import { render, staticRenderFns } from "./vessel-info.vue?vue&type=template&id=abfd4ac4&scoped=true&class=sensors-mainview&"
import script from "./vessel-info.vue?vue&type=script&lang=js&"
export * from "./vessel-info.vue?vue&type=script&lang=js&"
import style0 from "./vessel-info.vue?vue&type=style&index=0&id=abfd4ac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfd4ac4",
  null
  
)

export default component.exports